<script>
  import MissingPrivacyConsentPopup from "./MissingPrivacyConsentPopup.svelte";
  import superagent from "superagent";
  import { useQuery } from "@sveltestack/svelte-query";

  const user = localStorage.getItem("user");
  let currentUser = user !== null ? JSON.parse(user) : {};
  let showConsentPopup = user && currentUser.id && !currentUser.consent;

  const userMe = useQuery("me", () =>
    currentUser.id !== undefined
      ? superagent
          .get("/api/me")
          .set("Authorization", "Bearer " + currentUser.id)
          .then((response) => response.body)
      : undefined
  );
  $: if (!$userMe.isLoading && $userMe.data && user !== undefined) {
    currentUser = $userMe.data;
    showConsentPopup = user && currentUser.id && !currentUser.consent;
    localStorage.setItem("user", JSON.stringify(currentUser));
  }

  let showErrorMessage = false;

  function saveToServer(updatedUser) {
    return new Promise((resolve, reject) => {
      if (currentUser !== undefined) {
        console.log("[INFO] Save user information", updatedUser);
        superagent
          .post("/api/users/" + updatedUser.id + "/consent")
          .set({
            "Content-Type": "application/json",
            Authorization:
              updatedUser.id !== undefined
                ? "Bearer " + updatedUser.id
                : undefined,
          })
          .send(updatedUser)
          .then((response) => {
            currentUser = {
              ...updatedUser,
              id:
                updatedUser.id === undefined
                  ? response.body?.id
                  : updatedUser.id,
              rinkResults: response.body?.rinkResults,
              consent: response.body?.consent,
              version: response.body?.version,
            };
            localStorage.setItem("user", JSON.stringify(currentUser));
            resolve(currentUser);
          })
          .catch((error) => {
            console.log("[ERROR] Not able to save to server, got", error);
            reject(error);
          });
      } else {
        reject({ noUser: true });
      }
    });
  }

  function updateUser(updatedUser) {
    return new Promise((resolve, reject) => {
      currentUser = updatedUser;

      saveToServer(currentUser)
        .then((user) => {
          showConsentPopup = false;
          resolve(user);
        })
        .catch((error) => {
          showErrorMessage = true;
          reject(error);
        });
    });
  }
</script>

<MissingPrivacyConsentPopup
  bind:active={showConsentPopup}
  user={currentUser}
  {updateUser}
  bind:showErrorMessage
  bind:isLoading={$userMe.isLoading}
/>

<style>
</style>
